

<template>
	<div>
		<vFormItem :label="$t('fbb.warehouse.onsite_channel', { defaultValue: 'ONsite仓可使用渠道' })" label-width="150" v-if="type!=='query'">
			<vTransfer
				style="height:360px;"
				:data="getSourceDataList"
				identifier="value"
				:target-keys="targetKeys"
				:list-style="listStyle"
				:render-format="renderFormat"
                :filter-method="filterMethod"
				filterable
				@on-transfer="handleChange"
			></vTransfer>
		</vFormItem>
		<TableList v-else v-bind="getTableProps"></TableList>
	</div>
</template>

<script>
import TableList from "@components/templates/tablelist";
import { HttpManageWareChannelList } from '@/service/basicdata';
import { mapGetters } from 'vuex';
export default {
	props: ['data'],
	components: {
		TableList
	},
	data() {
		return {
			type: this.$route.params.type,
			id: this.$route.query.id,
			targetKeys: [],
			listStyle: {
				width: '30%',
				minWidth: '260px'
			},
		}
	},
	watch: {
		data: {
			immediate: true,
			handler(val) {
				this.targetKeys = (val || []).map(item => item.channelId);
			}
		}
	},
	computed: {
		...mapGetters('dictionary', ['getCusAccountList', 'getBillcusorgList']),
		getSourceDataList() {
			const obj = {};
			this.getBillcusorgList.forEach(item => {
				obj[item.value] = item.label;
			})
			// console.log(obj)
			return this.getCusAccountList.map(item => {
				return {
					...item,
					description: obj[item.attach.orgId]
				}
			})
		},
		getTableProps() {
			return {
				ajaxRequest: HttpManageWareChannelList,
				startUp: 1,
				initFormData: {
					id: this.id,
				},
				columns: [{
					title: this.$t('fbb.warehouse.sequence', { defaultValue: '序号' }),
					type: 'index',
					width: 100,
				}, {
					title: this.$t('erp.b2c.channel_account', { defaultValue: '渠道账号' }),
					key: 'key',
					render: (h, { row }) => this.findRenderLabel(this.getSourceDataList, row.key)
				}]
			}
		},
		getTargetData() {

			let tararray = []

			this.targetKeys.filter(key => {
				// console.log(key)
				const data = this.getCusAccountList.find(item => item.value == key);

				if(data){
					let itemdata = {
						"channelId": data.value,
						"channelCode": data.attach.flag,
						"orgId": data.attach.orgId
					}
					tararray.push(itemdata)
				}
			})
			// console.log(tararray)
			return tararray
		}
	},
	methods: {
		renderFormat(item) {
			return item.description ? `${item.label}-${item.description}` : item.label;
		},
		handleChange(targetKeys, direction, moveKeys) {
			// console.log(targetKeys)
			this.targetKeys = targetKeys;
		},
        // 添加自定义搜索函数,不区分大小写
        filterMethod (data, query) {
            return data.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        },
	}
}
</script>
